import { createContext, useCallback, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { isCabinetPath } from "./safeUrl";

/**
 * Сворачивание панели помощника. Ссылки ленты в кабинет открываются на
 * месте через роутер (без перезагрузки) и закрывают панель, чтобы
 * открытая страница не оставалась под ней, даже если адрес не изменился.
 */
export const AssistantCloseContext = createContext<() => void>(() => undefined);

export const useAssistantClose = () => useContext(AssistantCloseContext);

/** Переход в раздел кабинета из ленты: только пути /partner. */
export function useAssistantNavigate(): (url: string) => void {
  const navigate = useNavigate();
  const close = useAssistantClose();
  return useCallback(
    (url: string) => {
      if (!isCabinetPath(url)) return;
      navigate(url);
      close();
    },
    [navigate, close]
  );
}
